import PropTypes from 'prop-types';
import React from 'react';
import { InsurerHandoverButton } from 'ctm-components';

/**
 * The api schema
 */
const api = {
    url: '/event',
    type: 'POST',
    requestAction: 'ONLINE_HANDOVER',
    requestPayload: 'lead',
    failureType: 'non-fatal'
};

/**
 * Wrapper component for Home and Contents to render a handover button
 * @param {Object} props - component's props
 * @param {Object} props.stateProps - stateProps that passed from results_container, including product data and eventHandler
 * @returns {Node} the handover button or call direct button
 * @constructor
 */
const HandoverButton = ({ stateProps, ...buttonProps }) => {
    const { product, eventHandler } = stateProps;
    const providerCode = product.getIn(['providerMeta', 'code']);

    const getProviderDisplayName = (code) => {
        switch (code) {
            case 'BUDD':
                return 'Budget Direct';
            case 'VIRG':
                return 'Virgin';
            case 'EXPO':
                return 'Australia Post';
            case 'WOOL':
                return 'Everyday';
            case 'REIN':
            case 'REAL':
                return 'Real Insurance';
            case 'EXIG':
                return 'ING';
            case 'CHU':
                return 'CHU';
            case 'HUDD':
                return 'Huddle';
            case 'HONY':
                return 'Honey';
            case 'HBOQ':
                return 'BOQ';
            default:
                return 'Insurer';
        }
    };

    const provider = getProviderDisplayName(providerCode);

    return (
        <InsurerHandoverButton
            label={`Go to ${provider}`}
            icon="ctm_angle_right"
            iconPosition="after"
            target="_blank"
            href="/home-contents-insurance/journey/handover"
            variant="hover_grow_full_width"
            UIComponent="btn_feature_2_large_semi_rounded"
            api={api}
            stateProps={stateProps}
            {...buttonProps}
        />
    );
};

HandoverButton.propTypes = {
    stateProps: PropTypes.object.isRequired
};

export { HandoverButton };
